import { Buffer } from "buffer";
import { playerContext } from "@layouts/App/context/Player";
import { MediaRecorder, register } from "extendable-media-recorder";
import { connect } from "extendable-media-recorder-wav-encoder";
import { createSignal, onCleanup, useContext } from "solid-js";
await register(await connect());

const useRecordAudioClip = () => {
	const { player, handleTogglePlayer } = useContext(playerContext);
	const [chunks, setChunks] = createSignal<Blob>();
	const [mediaStream, setMediaStream] = createSignal<MediaStream>();

	const record = async (onDataCallback: (data: Buffer) => void) => {
		if (player.playing) handleTogglePlayer();

		try {
			const stream = await navigator.mediaDevices.getUserMedia({
				audio: { echoCancellation: false, noiseSuppression: false },
			});
			setMediaStream(stream);
			const mediaRecorder = new MediaRecorder(stream, { mimeType: "audio/wav" });
			mediaRecorder.ondataavailable = (e) => {
				setChunks(() => e.data);
			};
			mediaRecorder.onstop = async () => {
				for (const t of stream.getTracks()) t.stop();
				const ch = chunks();
				if (!ch) throw new Error("No chunks available");
				const arrayBuffer = await ch.arrayBuffer();
				const buffer = Buffer.from(arrayBuffer);
				onDataCallback(buffer);
			};
			return mediaRecorder;
		} catch {
			return;
		}
	};
	onCleanup(() => {
		const tr = mediaStream()?.getTracks();
		if (!tr) return;
		for (const t of tr) t.stop();
	});

	return record;
};

export default useRecordAudioClip;
